import { Navigate, Route, Routes } from 'react-router-dom'

import { PUBLIC_ROUTES, PRIVATE_ROUTES } from './routes'
import { StorageKeys } from '@/utils/constants'

export default function AuthRouter() {
  const accessToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN)

  if (!accessToken) {
    return (
      <Routes>
        {PUBLIC_ROUTES.map((route) => {
          const { path, component: Component, metaTags } = route

          return (
            <Route
              key={path}
              path={path}
              Component={() => (
                <>
                  {metaTags && (
                    <>
                      <title>{metaTags?.title}</title>
                      <meta
                        name="description"
                        content={metaTags?.description}
                      />
                    </>
                  )}
                  <Component />
                </>
              )}
            />
          )
        })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      {PRIVATE_ROUTES.filter((route) => route.path !== '/').map((route) => {
        const { path, component: Component, metaTags } = route
        return (
          <Route
            key={path}
            path={path}
            Component={() => (
              <>
                {metaTags && (
                  <>
                    <title>{metaTags?.title}</title>
                    <meta name="description" content={metaTags?.description} />
                  </>
                )}
                <Component />
              </>
            )}
          />
        )
      })}
      <Route path="*" element={<Navigate to="/gallery" replace />} />
    </Routes>
  )
}
